'use client'

export async function submit(formData: any) {
  const msg = [ 'Received contact form submission' ]
  for (const [key, value] of formData) {
    msg.push(`${key} => ${value}`)
  }
  msg.push('==================================================')
  console.log(msg.join('\n'))
  const response = await fetch(process.env.baseUrl + "/contact-form.html", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams(formData).toString(),
  })

  return response.ok
}
